import { render } from "./package_gallery.vue?vue&type=template&id=67ee00ac"
import script from "./package_gallery.vue?vue&type=script&lang=js"
export * from "./package_gallery.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__